import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";

const Menu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const exit = () => {
    dispatch({
      type: "@user/logout",
    });
    navigate("/");
  };

  return (
    <div>
      <div className="cFilas cFilasEnd pFRight">
        <div className="ball pFTop" onClick={exit}></div>
        <div className="mar-bottom pFBotton">
          <Link to="/settings">
            <FontAwesomeIcon icon={faGear} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Menu;
